import $store from '@/store'
import { APP_API_URL, APP_API_SALON_URL, APP_ORGANISATION, APP_ENVIRONMENT } from '@/utils/types/setting'
import { ENVIRONMENT } from '@/utils/constants'

const organisation = {
    name: 'Airbus',
    logo: `/static/img/organisations/airbus/logo.png`,
    logoLogin: `/static/img/organisations/airbus/logo-login.png`,
    logoMobile: `/static/img/organisations/airbus/logo.png`,
    background: `/static/img/organisations/airbus/background.jpg`
}

export default () => {
    $store.commit('base/setting/update', { key: APP_API_URL, value: 'https://happy.alterego-digital.eu/v1' })
    $store.commit('base/setting/update', {key: APP_API_SALON_URL, value: 'https://api-salon.alterego-digital.com/v1/external'})
    $store.commit('base/setting/update', { key: APP_ORGANISATION, value: organisation })
    $store.commit('base/setting/update', { key: APP_ENVIRONMENT, value: ENVIRONMENT.PROD })
}
